/* Parallax effect above 1280 resolution */
import Rellax from "rellax";

(function histallay_global($, Drupal, once) {
  Drupal.behaviors.histallay_global = {
    attach(context, settings) {
      function initializeRellax() {
        var screenWidth = window.innerWidth;
        if (screenWidth > 1366) {
          let rellax = new Rellax('.rellax');
        }
      }

      var xtlsmallSphereInBanner, ytlSmallSphere, ytlBigSphere, rotateLength;

      // $(document, context).once('histallay_global').each(function () {
      $(once('histallay_global', document, context)).each(function () {
        initializeRellax();

        xtlsmallSphereInBanner = 1000;
        ytlSmallSphere = 600;
        ytlBigSphere = 550;
        rotateLength = 600;
      });

      // Reinitialize Rellax when the window is resized
      window.addEventListener('resize', initializeRellax);

      // Global variables
      var currentScroll = $(window).scrollTop();
      var widnowHeightWithoutScroll = $(window).height() - currentScroll;

      // Individual elements variables
      if ($(".histallay-homepage-banner_top").length) {
        var smallSphereInBanner = $(".middle-content_right .sphere-small");
        var bigSphereInBanner = $(".histallay-homepage-banner_top > .sphere-small");

        var currLeftPositionsmallSphereInBanner = smallSphereInBanner.position().left;
        var currTopPositionsmallSphereInBanner = smallSphereInBanner.position().top;
        var currTopPositionOfbigSphereInBanner = bigSphereInBanner.position().top;
      }

      if ($(".histally-product-hero-banner").length) {
        var bigSphereInProductBanner = $(".histally-product-hero-banner .wrapper .background");
        var currTopPositionOfbigSphereInProductBanner = bigSphereInProductBanner.position().top;
      }

      $(window).on('scroll', function (event) {
        currentScroll = $(window).scrollTop();

        if (window.innerWidth >= 1366) {

          // Left on scroll animation

          if ($(".histallay-homepage-banner_top").length) {
            var newLeftPosition = xtlsmallSphereInBanner * (currentScroll / widnowHeightWithoutScroll);
            smallSphereInBanner.css({ left: currLeftPositionsmallSphereInBanner + newLeftPosition + 'px' });

            var newTopPosition = (ytlSmallSphere * (currentScroll / widnowHeightWithoutScroll));
            smallSphereInBanner.css({ top: currTopPositionsmallSphereInBanner + newTopPosition + 'px' });

            var newTopPosition = (ytlBigSphere * (currentScroll / widnowHeightWithoutScroll));
            bigSphereInBanner.css({ top: currTopPositionOfbigSphereInBanner + newTopPosition + 'px' });

            // Rotate on scroll animation
            var newRotation = (rotateLength * (currentScroll / widnowHeightWithoutScroll));
            smallSphereInBanner.css('transform', 'rotate(-' + newRotation + 'deg)');

            var newRotation = (rotateLength * (currentScroll / widnowHeightWithoutScroll));
            bigSphereInBanner.css('transform', 'rotate(' + newRotation + 'deg)');
          }

          if ($(".histally-product-hero-banner").length) {
            var newTopPosition = (ytlBigSphere * (currentScroll / widnowHeightWithoutScroll));
            bigSphereInProductBanner.css({ top: currTopPositionOfbigSphereInProductBanner + newTopPosition + 'px' });

            var newRotation = (rotateLength * (currentScroll / widnowHeightWithoutScroll));
            bigSphereInProductBanner.css('transform', 'rotate(' + newRotation + 'deg)');

          }
        }
      });
      // Modal related code.
      $('.tabs').find('.tablets').each(function (index) {
        $(this).on("click", function (e) {
          console.log("Clicked buy button");

          var id = $(this).attr("data-id");
          if (($('#' + id).hasClass('close-modal'))) {
            $('#' + id).addClass('open-modal');
          }
        });
      });
      $('.close').on("click", function (e) {
        e.stopPropagation();
        if ($(this).parents('.modal-tablet').hasClass('open-modal')) {
          $(this).parents('.modal-tablet').toggleClass('open-modal');
        }
      });
      $('.modal-img').each(function (index) {
        $(this).on("click", function (e) {
          $('.modal-img').removeClass('active');
          $(this).toggleClass('active');
        });
      });

    },
  };
})(jQuery, Drupal, once);
